import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import "./Hero.css";
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
    const [email, setEmail] = useState('');
    const [isSent, setIsSent] = useState(false);
    const navigate = useNavigate(); // Hook to programmatically navigate
  
    const sendEmail = (e) => {
      e.preventDefault();
  
      if (!email) {
        return;
      }
  
      const serviceID = 'service_gmotd25';
      const templateID = 'template_54d1x3i';
      const publicKey = 'no26ATx0bOIvBzFsy';
  
      const templateParams = {
        user_email: email, // Pass the email input value
        // to_email: 'caspertyson99@gmail.com',
        to_email: 'carleen@inspireproperty.co.nz',
      };
  
      emailjs.send(serviceID, templateID, templateParams, publicKey)
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
          setIsSent(true);
          navigate('/appraisal'); // Navigate to /contacts page after successful email
        })
        .catch((err) => {
          console.error('FAILED...', err);
        });
    };
  
    return (
        <section id="hero-1618">
            <div className="cs-container">
                <div className="cs-content">
                    <span className="cs-topper">
                        <svg className="cs-chevron" width="49" height="15" viewBox="0 0 49 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.7">
                                {/* Repeat the chevron paths here */}
                                {Array.from({ length: 6 }).map((_, index) => (
                                    <path
                                        key={index}
                                        d="M0.621948 7.49889L6.40262 15L10.343 15L4.56231 7.49889L10.343 0L6.40262 0L0.621948 7.49889Z"
                                        fill="var(--chevronColor)"
                                        transform={`translate(${index * 7}, 0)`}
                                    />
                                ))}
                            </g>
                        </svg>
                        carleen still
                        <svg className="cs-chevron" width="49" height="15" viewBox="0 0 49 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.7">
                                {Array.from({ length: 6 }).map((_, index) => (
                                    <path
                                        key={index}
                                        d="M48.3781 7.49889L42.5974 15L38.657 15L44.4377 7.49889L38.657 0L42.5974 0L48.3781 7.49889Z"
                                        fill="var(--chevronColor)"
                                        transform={`translate(-${index * 7}, 0)`}
                                    />
                                ))}
                            </g>
                        </svg>
                    </span>
                    {/* <h1 className="cs-title">North Island Lifestyle Block Sales + <br></br>Country Living</h1> */}
                    {/* <h1 className="cs-title">Real Estate for North Island Lifestyle + <br></br>Acreage</h1> */}
                    {/* <h1 className="cs-title">Lifestyle Block Sales + <br></br>North Island Property Expert</h1> */}
                    <h2 className="cs-title">Looking for someone <br></br>who cares?<br></br>Give me a call!</h2>
                    <h1 className="cs-subtitle">Real Estate in Waipu & Langs Beach — Coastal Homes, Residential Sales and Lifestyle Blocks</h1>
                    <div>
                    <input
                        type="email"
                        placeholder="Enter your email here..."
                        className="cs-email-input"
                        aria-label="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <a 
                        href="/appraisal" 
                        className="cs-button-solid"
                        onClick={(e) => {
                            e.preventDefault(); // stop immediate navigation
                            sendEmail(e);       // call your email function
                          }}                        
                    >GET FREE APPRAISAL</a>

                    </div>
                </div>
                <ul className="cs-card-group">
                    <li className="cs-item">
                        <img
                            className="cs-icon"
                            loading="lazy"
                            decoding="async"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/check-circle.svg"
                            alt="icon"
                            width="48"
                            height="48"
                        />
                        <h2 className="cs-h3">Free Appraisal</h2>
                        <p className="cs-item-text">
                        How much is your property worth? Enjoy a free, expert appraisal with zero obligations.
                        </p>
                    </li>
                    <li className="cs-item">
                        <img
                            className="cs-icon"
                            loading="lazy"
                            decoding="async"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/speedometer.svg"
                            alt="icon"
                            width="48"
                            height="48"
                        />
                        <h2 className="cs-h3">Client Focus</h2>
                        <p className="cs-item-text">
                            Our commitment to you is more than a transaction – it’s building a lasting partnership.                        </p>
                    </li>
                    <li className="cs-item">
                        <img
                            className="cs-icon"
                            loading="lazy"
                            decoding="async"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/Like.svg"
                            alt="icon"
                            width="48"
                            height="48"
                        />
                        <h2 className="cs-h3">Area Knowledge</h2>
                        <p className="cs-item-text">
                            Detailed knowledge of Waipu and Langs Beach, hidden gems and local growth spots.
                        </p>
                    </li>
                </ul>
            </div>
            <picture className="cs-background">
                <source media="(max-width: 600px)" srcSet="./uretiti3.webp" />
                <source media="(min-width: 601px)" srcSet="./uretiti3.webp" />
                <img
                    decoding="async"
                    src="./uretiti3.webp"
                    alt="meeting"
                    width="2250"
                    height="1500"
                    aria-hidden="true"
                    fetchpriority="high"
                />
            </picture>
        </section>
    );
};

export default HeroSection;
